import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import './App.css';

import { Home } from './pages/Home';
import { Schedule } from './pages/Schedule';
import { Prediction } from './pages/Prediction';
import { CheckTicket } from './pages/CheckTicket';
import { Leaderboard } from './pages/Leaderboard';
import { Winners } from './pages/Winners';
import { Partners } from './pages/Partners';
import { Terms } from './pages/Terms';
import { NotFound } from './pages/NotFound';

import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminTerms } from './pages/admin/AdminTerms';
import { AdminLeaderboard, AdminWinners } from './pages/admin/AdminLeaderboardWinners';
import { AdminMatches } from './pages/admin/AdminMatches';
import { AdminPartners } from './pages/admin/AdminPartners';
import { AdminTeams, AdminWebsites } from './pages/admin/AdminTeamsWebsites';
import { AdminTickets } from './pages/admin/AdminTickets';
import { AdminSettings } from './pages/admin/AdminSettings';
import { PageTitleUpdater } from './components/PageTitleUpdater';

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
        <PageTitleUpdater />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: 'rgba(255, 255, 255, 0.08)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.12)',
              color: 'white',
              borderRadius: '18px',
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/prediction/:matchId" element={<Prediction />} />
          <Route path="/check-ticket" element={<CheckTicket />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/winners" element={<Winners />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/terms" element={<Terms />} />

          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/matches" element={<ProtectedRoute><AdminMatches /></ProtectedRoute>} />
          <Route path="/admin/teams" element={<ProtectedRoute><AdminTeams /></ProtectedRoute>} />
          <Route path="/admin/websites" element={<ProtectedRoute><AdminWebsites /></ProtectedRoute>} />
          <Route path="/admin/partners" element={<ProtectedRoute><AdminPartners /></ProtectedRoute>} />
          <Route path="/admin/leaderboard" element={<ProtectedRoute><AdminLeaderboard /></ProtectedRoute>} />
          <Route path="/admin/winners" element={<ProtectedRoute><AdminWinners /></ProtectedRoute>} />
          <Route path="/admin/terms" element={<ProtectedRoute><AdminTerms /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
          <Route path="/admin/predictions" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/tickets" element={<ProtectedRoute><AdminTickets /></ProtectedRoute>} />
          <Route path="/admin/participants" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
